import { useAtom } from "jotai";
import { Fragment } from "react";
import Button from "components/base/Button";
import Backdrop from "components/common/Backdrop";
import { user_info } from "jotai/UserJotaiInstance";
import { Col, ListGroup, Row } from "react-bootstrap";
import useConnectedEmails from "hooks/useConnectedEmails";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useUnauthorizedObserver from "hooks/useUnauthorizedObserver";
import { UserInfo } from "interfaces/user";

const ConnectNewEmail = () => {
  const [userInfo] = useAtom<UserInfo>(user_info);
  const connectedEmails = useConnectedEmails();
  const isAuthorized = userInfo?.payment_status === "Cancelled" ? false : true;

  useUnauthorizedObserver(isAuthorized);

  const handleConnectWithGoogle = () => {
    if(process.env.NODE_ENV === "development") {
      window.location.href = "http://localhost:8080/api/google/connect/auth";
    } else {
      window.location.href = "https://app.kairosiq.ai/api/google/connect/auth";
    }
  };

  const isGmailConnected = connectedEmails.some((email: { provider: string }) => email.provider === "gmail");

  return (
    <Fragment>
      <h3 className="mb-4">New Account</h3>
      <Row>
        <Col xl={6} xxl={4}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h6>New account</h6>
              <p className="mb-0">Connect a new account to your workspace</p>
            </div>
          </div>
          <ListGroup className="mb-4">
            <ListGroup.Item>Choose your provider</ListGroup.Item>
            <ListGroup.Item>
            <div className="d-flex justify-content-center py-4 align-items-center">
              <div className="d-flex align-items-center gap-3">
                {isGmailConnected ? (
                  <span className="text-muted">
                    You've already connected a Gmail account.
                  </span>
                ) : (
                  <Button
                    onClick={handleConnectWithGoogle}
                    variant="phoenix-secondary"
                    startIcon={<FontAwesomeIcon icon={faGoogle} />}
                  >
                    Connect with Google
                  </Button>
                )}
              </div>
            </div>
          </ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
      {!isAuthorized && <Backdrop />}
    </Fragment>
  );
};

export default ConnectNewEmail;
